import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import colors from '../../../assets/theme/colors';

const MobilePullRefreshIndicator = ({ pullDistance, isRefreshing }) => {
  const isVisible = pullDistance > 0 || isRefreshing;

  return (
    <Box
      sx={{
        height: isVisible ? 44 : 0,
        mb: isVisible ? 0.75 : 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        transition: 'height 180ms ease, margin-bottom 180ms ease',
      }}
    >
      {isRefreshing ? (
        <CircularProgress size={18} thickness={5} sx={{ color: colors.brand.ink }} />
      ) : pullDistance > 0 ? (
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: '9999px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: colors.landing.surface,
            border: `1px solid ${colors.landing.borderLight}`,
            boxShadow: `0 8px 18px ${colors.landing.shadowSoft}`,
            transform: `translateY(${Math.min(12, pullDistance / 6)}px) rotate(${Math.min(180, (pullDistance / 72) * 180)}deg)`,
            color: colors.landing.textMuted,
          }}
        >
          <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
        </Box>
      ) : null}
    </Box>
  );
};

export default MobilePullRefreshIndicator;
